import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Fires a GA4 page_view on every React Router navigation.
 * Placed inside <BrowserRouter> in App.js.
 */
export default function AnalyticsListener() {
  const location = useLocation();
  useEffect(() => {
    // Slight delay so document.title (set by Helmet) has updated
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search, document.title);
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);
  return null;
}
